import { useState, useEffect, useCallback } from 'react'
import api from '@api'

export interface Mapping {
  id: string
  csv: string
  siq: string | undefined | null
}

export default function useIportMappings() {
  const [mappings, setMappings] = useState<any[]>([])
  const [storedMappings, setStoredMappings] = useState<any>({})
  const [mappingChecklist, setMappingChecklist] = useState([
    {
      children: 'Full name',
      pass: mappings.some((m) => m.siq === 'name'),
    },
    {
      children: 'Department',
      pass: mappings.some((m) => m.siq === 'department_name'),
    },
    {
      children: 'Email',
      pass: mappings.some((m) => m.siq === 'email'),
    },
    {
      children: 'Employment Type',
      pass: mappings.some((m) => m.siq === 'employment_type'),
    },
  ])

  useEffect(() => {
    api.employee.import.mapping().then((storedMappings) => {
      setStoredMappings(storedMappings)
    })
  }, [])

  useEffect(() => {
    setMappingChecklist([
      {
        children: 'Full Name',
        pass:
          mappings.some((m) => m.siq === 'name') ||
          (mappings.some((m) => m.siq === 'first_name') &&
            mappings.some((m) => m.siq === 'last_name')),
      },
      {
        children: 'Department',
        pass: mappings.some((m) => m.siq === 'department_name'),
      },
      {
        children: 'Email',
        pass: mappings.some((m) => m.siq === 'email'),
      },
      {
        children: 'Employment Type',
        pass: mappings.some((m) => m.siq === 'employment_type'),
      },
    ])
  }, [mappings])

  const initMappings = useCallback(
    (fileColumns: string[]) => {
      function initMapping(cvsColumn: any) {
        let initValue

        if (cvsColumn) {
          for (const [key, value] of Object.entries(storedMappings)) {
            if (!initValue && value === cvsColumn) {
              initValue = key
            }
          }
        }

        return initValue
      }

      setMappings(
        fileColumns.map((f, i) => ({
          id: String(i),
          csv: f,
          siq: initMapping(f),
        }))
      )
    },
    [storedMappings]
  )

  return {
    mappings,
    mappingChecklist,
    setMappings,
    initMappings,
    mappingComplete: mappingChecklist.every(({ pass }) => pass),
  }
}
